import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgPlayOutline = function SvgPlayOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4.6764C5 2.49701 7.4142 1.18362 9.24394 2.36758L20.5624 9.69133C20.5624 9.69133 20.5624 9.69133 20.5624 9.69133C22.2372 10.775 22.2372 13.2252 20.5624 14.3089C20.5624 14.3089 20.5624 14.3089 20.5624 14.3089L9.24394 21.6327L9.24392 21.6327C7.41417 22.8166 5 21.5032 5 19.3238V4.6764ZM8.42906 3.62693C7.59736 3.08877 6.5 3.68576 6.5 4.6764V19.3238C6.5 20.3144 7.59735 20.9114 8.42906 20.3733C8.42907 20.3733 8.42907 20.3733 8.42908 20.3733L19.7476 13.0495L19.7476 13.0495C20.5088 12.557 20.5088 11.4432 19.7476 10.9507L19.7476 10.9507L8.42906 3.62693L8.8365 2.99726L8.42906 3.62693Z"
  })));
};

export { SvgPlayOutline as ReactComponent };
//# sourceMappingURL=play-outline.svg.js.map
